import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils, write } from "xlsx";
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import Papa from "papaparse";
import moment from "moment";

import { DropDownField, TextInputField, CheckboxField, AutoCompleteField } from "../../../helpers";
import Button from "../../../helpers/Button";
import DateFilter from "../../../common/DateFilter";
import Loading from "../../../common/Loading";

import { searchInvoiceBookingRaw } from '../../../services/api/invoiceBooking';
import { fetchInvoiceBookingList, updateSearchParams, updateSearchOptions, updateLoading, setSearchConfig, setIsSearchByLocked } from "../../../services/redux/reducers/invoiceBooking/invoiceBooking";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { getFullName, getAddFilterOptions, getAutoSearchSuggestions, getDateRange, getMatchedRegexPattern, normalizeLabel, round, useFuzzSearch } from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { DATE_FORMAT } from "../../../constants";


const invoiceBookingSearchConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        disabled: false,
        options: [
            { label: 'Invoice Data', value: 'invoiceData' }
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    // {
    //     srNO: 2,
    //     static: true,
    //     type: "SEARCH_BY",
    //     name: "searchBy",
    //     label: "Search by",
    //     disabled: false,
    //     options: [
    //         { label: 'No Filters', value: 'all' },
    //         { label: 'Company Name', value: 'companyName' },
    //         { label: 'Seller PI No.', value: 'sellerPINo' },
    //         { label: 'Seller PO No.', value: 'sellerPODocNo' },
    //         { label: 'E-Invoice No.', value: 'EInvoiceNo' },
    //         { label: 'KAM Name', value: 'kamName' },
    //         { label: 'Kam Email', value: 'kamEmail' },
    //         { label: 'GSTIN', value: 'gstinCode' },
    //         { label: 'Verified By', value: 'verifiedBy'},
    //         { label: 'Booked By', value: 'bookedBy' }
    //     ]
    // },
    // {
    //     srNO: 2,
    //     static: true,
    //     type: "SEARCH_BY",
    //     name: "searchBy",
    //     label: "Search by",
    //     disabled: false,
    //     options: [
    //         { label: 'No Filters', value: 'all' },
    //         { label: 'Company Name', value: 'companyName' },
    //         { label: 'Seller PI No.', value: 'sellerPINo' },
    //         { label: 'Seller PO No.', value: 'sellerPODocNo' },
    //         { label: 'KAM Name', value: 'kamName' },
    //         { label: 'Kam Email', value: 'kamEmail' },
    //         { label: 'GSTIN', value: 'gstinCode' },
    //         { label: 'Booked By', value: 'bookedBy' }
    //     ]
    // },
    {
        srNO: 3,
        static: true,
        type: "DATE",
        name: "dateType",
        label: "Date",
        disabled: false,
        options: [
            { label: 'PI Uploaded Date', value: 'piUploadedDate' },
            { label: 'PI Created Date', value: 'createdAt' },
            { label: 'Purchase Invoice Date', value: 'sellerPIDate' },
            { label: 'SellerPO Created Date', value: 'sellerPODate' },
            { label: 'PI Booked Date', value: 'piBookedDate' },
            { label: 'PI Verified Date', value: 'piVerifiedDate' },
        ]
    },
    {
        srNO: 4,
        static: false,
        type: "SELECT",
        name: "bookedStatus",
        label: "Booking Status",
        disabled: false,
        options: [
            { label: 'Booked', value: true },
            { label: 'UnBooked', value: false }
        ]
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "pmBranchId",
        label: "Branch",
        disabled: false
    },
    {
        srNO: 6,
        static: false,
        type: "SELECT",
        name: "POType",
        label: "PO Type",
        disabled: false,
        options: [
            { label: 'NORMAL', value: 'NORMAL' },
            { label: 'EXPENSE', value: 'EXPENSE' }
        ]
    },
    {
        srNO: 7,
        static: false,
        type: "SELECT",
        name: "expenseCategoryId",
        label: "Expense Category",
        disabled: false
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPODocNo",
        label: "Seller PO No.",
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPINo",
        label: "Seller PI No.",
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "AUTO_COMPLETE",
        name: "kamName",
        label: "Kam Name",
        priority: 1
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "companyName",
        label: "Company Name",
        priority: 2
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "kamEmail",
        label: "Kam Email",
    },
    {
        srNO: 13,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "gstin",
        label: "GSTIN",
    },
    {
        srNO: 14,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "bookedBy",
        label: "Booked By",
    },
    {
        srNO: 15,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "verifiedBy",
        label: "verified By",
    },
    {
        srNO: 16,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label: "Doc No",
    }
]

const docNoSearchLabels = ["sellerPODocNo", "sellerPINo", "docNo", "EInvoiceNo"]


const PIInvoiceBookingSearch = (props) => {
    const { expenseCategories } = props

    const dispatch = useDispatch()
    const [suggestions, setSuggestions] = useState([])
    const [isDataLoading, setIsDataLoading] = useState(false)

    const isLoading = useSelector(state => state.invoiceBookingPIWise.loading)
    const paginationParams = useSelector(state => state.invoiceBookingPIWise.paginationParams)
    const searchParams = useSelector(state => state.invoiceBookingPIWise.searchParams)
    const searchOptions = useSelector(state => state.invoiceBookingPIWise.searchOptions)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const states = useSelector(state => state.common.states)
    const userDetails = useSelector(state => state.userDetails)
    const isSearchByLocked = useSelector(state => state.invoiceBookingPIWise.isSearchByLocked)

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const searchConfig = [...invoiceBookingSearchConfig]

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const userId = userDetails.userId
    const usersList = userDetails.PMCompanyDetails.companyUsers
    const companyBranches = userDetails.PMCompanyDetails.companyBranches

    let pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers ? userDetails.PMCompanyDetails.companyUsers : []

    pmCompanyUsers = pmCompanyUsers.map(eachPerson => {
        const name = getFullName(eachPerson.firstName, eachPerson.lastName)
        return { ...eachPerson, displayName: name }
    })


    useEffect(() => {
        dispatch(setSearchConfig(invoiceBookingSearchConfig))
        if (searchOptions.length === 0) {
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        if (searchTextRef.current) {
            searchTextRef.current.focus()
        }
    }, [searchParams.searchBy])

    useEffect(() => {
        if (['kamName'].includes(searchParams.searchBy)) {
            autoCompleteSearch(searchParams.searchBy, searchParams.searchText)
        }
    }, [searchParams.searchBy])

    const kamFuzzSearch = useFuzzSearch(pmCompanyUsers, "displayName")

    useEffect(() => {
        if (pmCompanyConfig.isSellerEInvoiceApplicable){
            searchConfig.push( {
                srNO: 8,
                static: false,
                type: "SELECT",
                name: "isEInvoiceUploaded",
                label: "E-Invoice",
                options: [
                    { label: 'Uploaded', value: true },
                    { label: 'Not Uploaded', value: false }
                ]
            })
        }
    }, [userDetails])

    const addFilterOption = (srNO) => {
        let relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        if (relatedConfig.name === "pmBranchId") {
            const updatedCompanyBranches = companyBranches.map(eachCompanyBranch => ({ ...eachCompanyBranch, label: eachCompanyBranch.branchName, value: eachCompanyBranch.branchId }))
            relatedConfig = {...relatedConfig, options: updatedCompanyBranches}
        }
        if (relatedConfig.name === "expenseCategoryId") {
            const updatedExpenseCategories = expenseCategories.map(eachCategory => ({ ...eachCategory, label: eachCategory.expenseCategoryName, value: eachCategory.expenseCategoryId }))
            relatedConfig = {...relatedConfig, options: updatedExpenseCategories}
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = { ...searchParams }

        if (relatedSearchOption.type === "SEARCH_BY") {
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "DATE") {
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.range = ""
            console.log("updateSearchParams", updatedSearchParams)
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "SELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "AUTO_COMPLETE") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleCheckboxSelect = (event) => {
        const updatedSearchParams = {
            ...searchParams,
            [event.target.name]: event.target.checked
        }
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        if (eventValue && (eventValue.userId || eventValue.companyId)) {
            eventValue = eventValue.displayName
        }

        const updatedSearchParams = { ...searchParams }
        
        updatedSearchParams[event.target.name] = eventValue

        if (["fromDate", "toDate"].includes(event.target.name)) {
            if (eventValue instanceof Date) {
                if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                    updatedSearchParams.range = null
                }

                if (event.target.name === "toDate") {
                    eventValue.setHours(23, 59, 0, 0)
                }
                if (event.target.name === "fromDate") {
                    eventValue.setHours(0, 0, 0, 0)
                }
                eventValue = eventValue.toISOString()

                updatedSearchParams[event.target.name] = eventValue
            }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        else if (["searchBy"].includes(event.target.name)) {
            const updatedSearchOptions = searchOptions.map(eachOption => {
                const updatedOption = { ...eachOption }
                if (updatedOption.name === "dateType") {
                    updatedOption.disabled = ["sellerPINo", "sellerPODocNo"].includes(event.target.value) ? true : false
                }
                return updatedOption
            })
            dispatch(updateSearchOptions([...updatedSearchOptions]))

            dispatch(updateSearchParams(updatedSearchParams))
        }
        else {
            if(event.target.name === "searchText" && event.target.value.length > 3) {
                const availableOptions = [...invoiceBookingSearchConfig]
                const matchText = eventValue.split(";")[0]
                const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
                if(!isSearchByLocked){
                    updatedSearchParams.searchBy = matchedPattern
                }
            }

            if (event.target.name === "searchBy"){
                dispatch(setIsSearchByLocked(true))
            }

            dispatch(updateSearchParams(updatedSearchParams))
        }
    }

    const handleSearchByLock = () => {
        if(isSearchByLocked && searchParams.searchText === ""){
            const updatedSearchParams = { ...searchParams, searchBy : "all" }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        else if(isSearchByLocked && searchParams.searchText !== ""){
            const availableOptions = [...invoiceBookingSearchConfig]
            const matchedPattern = getMatchedRegexPattern(searchParams.searchText, availableOptions, searchParams.searchBy)
            const updatedSearchParams = { ...searchParams, searchBy : matchedPattern }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        dispatch(setIsSearchByLocked(!isSearchByLocked))
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const autoCompleteSearch = (searchType, query) => {
        const suggestions = getAutoSearchSuggestions({
            searchType,
            query,
            pmCompanyUsers,
            kamFuzzSearch,
        })

        setSuggestions(suggestions)
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const isSearchByVisible = searchParams.searchText || isSearchByLocked

    const downloadPurchaseData = async (dataFormat) => {
        //if (window.confirm("Downloading will mark the verified and unbooked rows as booked - are you sure you want to continue?")) {
        if(true){
            const updatedSearchParams = { ...searchParams }
            if(updatedSearchParams.searchBy !== "all"){
                updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
            }

            setIsDataLoading(true)
            const response = await searchInvoiceBookingRaw({ ...updatedSearchParams, downloadFlag: true, verificationStatus: 'VERIFIED' })
            if (response.failure) {
                setIsDataLoading(false)
                return dispatch(raiseToast({severity: "error", summary: "Invoice Download", detail: response.data.error, life: 3000}))
            }

            const sellerPIPunchItems = response.data.sellerPIPunchItems
            const seller_purchase_invoices = response.data.data

            const unBookedInvoices = seller_purchase_invoices.filter(eachSellerPIPunch => eachSellerPIPunch.verifiedBy && !eachSellerPIPunch.bookedBy)
            const unBookedInvoiceSellerPIPunchDocNos = unBookedInvoices.map(eachInv => eachInv.PIDocNo)
            const bookingLogs = unBookedInvoices.map(eachSellerPIPunch => {
                return {
                    docNo: eachSellerPIPunch.PIDocNo,
                    bookedBy: userId,
                    bookedAt: new Date(),
                    relatedTicket: eachSellerPIPunch.tickets?.length ? eachSellerPIPunch.tickets[0] : null,
                    remarks: 'Booked automatically by download'
                }
            })

            /*const data = {
                docNos: unBookedInvoiceSellerPIPunchDocNos,
                bookingStatus: true,
                updatedBy: userId,
                bookingLogs: bookingLogs,
                closeTicket: false
            }
            const bookingStatusRes = await updatePurchaseInVoiceBookingStatus(data)
            if (bookingStatusRes.failure) {
                dispatch(updateLoading(false))
                dispatch(raiseToast({ severity: 'error', summary: 'Booking Status is not Updated', detail: bookingStatusRes.data.error, life: 3000 }))
            }*/

            let purchase_data = []

            const state_code = {
                'MAHARASHTRA': 'M',
                'DELHI': 'D',
                'GOA': 'G',
                'GUJARAT': 'GJ',
                'HARYANA': 'HR',
                'KARNATAKA': 'K',
                'TAMIL NADU': 'TN',
                'CHHATTIGARH': 'CG',
                'WEST BENGAL': 'WB',
                'UTTAR PRADESH': 'U'
            }

            const city_code = [
                { code: "", city_arr: ["GOA", "MAHARASHTRA"] },
                { code: "Baddi", city_arr: ["HARYANA", "PANCHKULA", "BADDI"] },
                { code: "DEL", city_arr: ["DELHI"] },
                { code: "Gujarat", city_arr: ["AHMEDABAD", "GUJARAT"] },
                { code: "Kolkata", city_arr: ["WEST BENGAL", "KOLKATA"] },
                { code: "Chennai", city_arr: ["TAMIL NADU", "CHENNAI"] },
                { code: "Bengaluru", city_arr: ["BENGALURU"] },
                { code: "Hyderabad", city_arr: ["HYDERABAD"] },
                { code: "Odisha", city_arr: ["BHADRAK", "ODISHA"] }
            ]

            let unVerifiedPIExists = false

            seller_purchase_invoices.map(pi => {

                if(!pi.verifiedBy){
                    unVerifiedPIExists = true
                }

                let sellerpo = pi.currentSellerpo
                let GSTType = pi.GSTType

                let vch_type = 'Purchase'
                let kamId = pi.sellerPOCreatedBy
                let filtered_kam_obj = usersList.find(kam => kam.userId === kamId)
                let pmBranchId = pi.pmBranchId
                let relatedPMBranch = companyBranches.find(obj => obj.branchId === pmBranchId)
                let relatedTicket = null
                if(pi.tickets && pi.tickets.length){
                    relatedTicket = pi.tickets[0]
                }

                const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
                let branchHead = null
                pmCompanyUsers.map(eachCompanyUser => {
                    if (eachCompanyUser.statusId === 1) {
                        eachCompanyUser.userRoles.map(eachUserRole => {
                            if (eachUserRole.branchId === pmBranchId && eachUserRole.statusId === 1, eachUserRole.companyRoleId === 3) {
                                branchHead = `${eachCompanyUser?.firstName} ${eachCompanyUser?.lastName}`
                            }
                        })
                    }
                })

                if (!pi.expenseCategoryId) {
                    if (filtered_kam_obj) {
                        let req_city_obj = city_code.find(city => city.city_arr.includes(relatedPMBranch?.branchName?.toUpperCase()))
                        if (req_city_obj) {
                            vch_type = vch_type + ' ' + req_city_obj.code
                        }
                    }
                }
                else {
                    vch_type = vch_type + ' ' + "Expense"
                }

                let trade_name = ''

                if (pi["sellerAddrs.ledgerName"]) {
                    trade_name = pi["sellerAddrs.ledgerName"]
                }
                /*if (!pi["sellerAddrs.gstinCode"]) { // || pi.isImport
                    let state_code
                    trade_name = pi.companyName
                    let state_id = pi["sellerAddrs.stateId"]
                    let relatedState = states.find(obj => obj.stateId === state_id)
    
                    if (relatedState) {
                        state_code = relatedState.stateCode
                    }
                    trade_name = trade_name + "_" + state_code
                } else {
                    if (pi["sellerAddrs.gstinCode"]) {
                        let state_code
                        trade_name = pi["sellerAddrs.ledgerName"]
                        
                        let relatedState = states.find(obj => obj.stateId === pi["sellerAddrs.stateId"])
                        if (relatedState) {
                            state_code = relatedState.stateCode
                        }
                        trade_name = trade_name + "_" + state_code
                    } else {
                        trade_name = ''
                    }
                }*/

                let logistics_hsn = ''
                let logistics_igst_percentage = ''
                let logistics_sgst_percentage = ''
                let logistics_cgst_percentage = ''

                let logistics_igst_amount = ''
                let logistics_sgst_amount = ''
                let logistics_cgst_amount = ''

                let logistics_igst_ledger = ''
                let logistics_sgst_ledger = ''
                let logistics_cgst_ledger = ''

                let logistics_quantity = 1
                let logistics_amount = 0

                let logistics_tds_ledger = ''
                let logistics_tds_amt = ''

                let logistics_purchase_ledger = ''

                logistics_hsn = pi["sellerPOlogisticsHSNCode"]
                let logisticsGSTRate = pi["sellerPOlogisticsGSTRate"]
                let logisticsTaxAmount = 0
                let logisticsTDSValue = pi["sellerPOlogisticsTDSValue"]

                let logisticsBeforeTax
                if (pi["sellerPILogisticsWithTax"]) {
                    let logisticsGSTRateValue = logisticsGSTRate / 100
                    logisticsBeforeTax = pi["sellerPILogisticsWithTax"] / (1 + logisticsGSTRateValue)

                    logisticsTaxAmount = round(pi["sellerPILogisticsWithTax"] - logisticsBeforeTax, 2)
                }

                // Logistic Charge IGST,SGST,CGST percentages
                if (GSTType === "I" && logisticsGSTRate) {
                    logistics_igst_percentage = logisticsGSTRate
                }
                if (GSTType !== "I" && logisticsGSTRate) {
                    logistics_sgst_percentage = logisticsGSTRate / 2
                }
                if (GSTType !== "I" && logisticsGSTRate) {
                    logistics_cgst_percentage = logisticsGSTRate / 2
                }

                // Logistic Charge IGST,SGST,CGST amount(rate,values)
                if (GSTType === "I") {
                    logistics_igst_amount = logisticsTaxAmount
                } else if (logisticsTaxAmount) {
                    logistics_sgst_amount = round(logisticsTaxAmount / 2, 2)
                    logistics_cgst_amount = round(logisticsTaxAmount / 2, 2)
                }

                // Logistics TDS amount
                if (pi["sellerPIlogisticsBeforeTax"]) {
                    logistics_tds_amt = round(logisticsTDSValue * pi["sellerPIlogisticsBeforeTax"])
                }

                // Logistics TDS ledger
                logistics_tds_ledger = pi["sellerPOlogisticsTDSSection"]

                let vch_date;
                let sellerPIDate = new Date(pi["sellerPIDate"])
                if (sellerPIDate.getMonth() != new Date().getMonth()) {
                    vch_date = new Date()
                    vch_date.setDate(1)
                } else {
                    vch_date = sellerPIDate
                }

                let logisticAddedFlag = false

                let pmStateId = pi["pmBillAddrs.stateId"]
                let pmState = states.find(obj => obj.stateId === pmStateId)
                let pmStateName = pmState.stateName?.toUpperCase()

                //const relatedSellerPIPunchItems = sellerPIPunchItems.filter(eachPIPunch => eachPIPunch.sellerPIPunchId === pi["sellerPIPunchId"])

                const relatedSellerPIPunchItems = pi.punchItems

                relatedSellerPIPunchItems.map(eachSellerPIPunchItem => {
                    let itemGSTRate = eachSellerPIPunchItem.GSTRate
                    let itemCSGSTRate = eachSellerPIPunchItem.GSTRate ? parseInt(eachSellerPIPunchItem.GSTRate) / 2 : 0

                    let IGST = GSTType === "I" ? itemGSTRate : 0;
                    let IGST_Ledger = IGST ? `${state_code[pmStateName]} IGST On Input @ ${IGST} %` : '';

                    let SGST = GSTType !== "I" ? itemCSGSTRate : 0;
                    let SGST_Ledger = SGST ? `${state_code[pmStateName]} SGST On Input @ ${SGST} %` : '';

                    let CGST = GSTType !== "I" ? itemCSGSTRate : 0;
                    let CGST_Ledger = CGST ? `${state_code[pmStateName]} CGST On Input @ ${CGST} %` : '';

                    let tds_amount = eachSellerPIPunchItem.tdsAmount ? eachSellerPIPunchItem.tdsAmount : 0
                    let tds_ledger = eachSellerPIPunchItem.tdsSection

                    let hsn_description;
                    let item_name = eachSellerPIPunchItem.productName;
                    let hsn_obj;
                    HSNMasterData.map((obj, key) => {
                        if (obj.HSNCode == eachSellerPIPunchItem.HSNCode) {
                            hsn_obj = obj.HSNCode
                        }
                    })
                    if (item_name || hsn_obj) {
                        hsn_description = item_name + ":" + hsn_obj
                    } else {
                        hsn_description = ''
                    }

                    if (!hsn_obj) {
                        console.log("no hsn")
                        hsn_obj = '99010011'
                    }

                    if (hsn_obj) {
                        hsn_obj = "" + hsn_obj
                    }

                    let purchase_ledger = '';
                    let purchase_type = hsn_obj.startsWith('99') ? 'Services' : 'Goods'
                    if (IGST) {
                        purchase_ledger = `IGST Purchase @ ${IGST} %_${purchase_type}`
                    } else if (CGST) {
                        purchase_ledger = `Purchase Basic @ ${SGST + CGST} %_${purchase_type}`
                    } else if (IGST == CGST) {
                        if (pmStateId == pi["sellerAddrs.stateId"]) {
                            purchase_ledger = `IGST Purchase @ ${IGST} %`
                        } else {
                            purchase_ledger = `Purchase Basic @ ${CGST} %`
                        }
                    }

                    if (pi.expenseCategoryId) {
                        const relatedExpenseCategory = expenseCategories.find(eachExpenseCategory => eachExpenseCategory.expenseCategoryId === pi.expenseCategoryId)
                        if (relatedExpenseCategory) {
                            if (IGST) {
                                purchase_ledger = `IGST ${relatedExpenseCategory.expenseCategoryName} @ ${IGST} %_${purchase_type}`
                            } else if (CGST) {
                                purchase_ledger = `${relatedExpenseCategory.expenseCategoryName} @ ${SGST + CGST} %_${purchase_type}`
                            } else if (IGST == CGST) {
                                if (pmStateId == pi["sellerAddrs.stateId"]) {
                                    purchase_ledger = `IGST ${relatedExpenseCategory.expenseCategoryName} @ ${IGST} %`
                                } else {
                                    purchase_ledger = `${relatedExpenseCategory.expenseCategoryName} @ ${CGST} %`
                                }
                            }
                        }
                    }

                    let logistics_hsn_obj;
                    HSNMasterData.map((obj, key) => {
                        if (obj.HSNCode == pi["sellerPOlogisticsHSNCode"]) {
                            logistics_hsn_obj = obj.HSNCode
                        }
                    })

                    if (!logistics_hsn_obj) {
                        console.log("no hsn")
                        logistics_hsn_obj = '99010011'
                    }

                    if (logistics_hsn_obj) {
                        logistics_hsn_obj = "" + logistics_hsn_obj
                    }

                    let logistics_purchase_type = logistics_hsn_obj.startsWith('99') ? 'Services' : 'Goods'
                    if (logistics_igst_percentage) {
                        logistics_purchase_ledger = `IGST Purchase @ ${logisticsGSTRate} %_${logistics_purchase_type}`
                    } else if (logistics_sgst_percentage) {
                        logistics_purchase_ledger = `Purchase Basic @ ${logistics_sgst_percentage + logistics_sgst_percentage} %_${logistics_purchase_type}`
                    } else if (logistics_igst_percentage == logistics_sgst_percentage) {
                        if (pmStateId == pi["sellerAddrs.stateId"]) {
                            logistics_purchase_ledger = `IGST Purchase @ ${logistics_igst_percentage} %`
                        } else {
                            logistics_purchase_ledger = `Purchase Basic @ ${logistics_sgst_percentage} %`
                        }
                    }

                    let transportation_ledger = ''
                    let transportation_amt = ''

                    if (IGST && logisticAddedFlag == false && IGST == logisticsGSTRate) {
                        logistics_igst_ledger = 'M IGST On Input @ ' + logisticsGSTRate + "%"
                        if (pi["sellerPILogisticsWithTax"]) {
                            logistics_amount = pi["sellerPILogisticsWithTax"]
                        }
                        logisticAddedFlag = true
                    }

                    else if (CGST && CGST == logistics_sgst_percentage) {
                        if (!logisticAddedFlag) {
                            logistics_cgst_ledger = 'M CGST On Input @ ' + logistics_sgst_percentage + "%"
                            logistics_sgst_ledger = 'M SGST On Input @ ' + logistics_sgst_percentage + "%"
                            if (pi["sellerPILogisticsWithTax"]) {
                                logistics_amount = pi["sellerPILogisticsWithTax"]
                            }
                            logisticAddedFlag = true
                        }
                    }
                    else if (SGST && SGST == logistics_sgst_percentage) {
                        if (!logisticAddedFlag) {
                            logistics_sgst_ledger = 'M SGST On Output @ ' + logistics_sgst_percentage + "%"
                            if (pi["sellerPILogisticsWithTax"]) {
                                logistics_amount = pi["sellerPILogisticsWithTax"]
                            }
                            logisticAddedFlag = true
                        }
                    }
                    else {
                        if (pi["sellerPILogisticsWithTax"]) {
                            logistics_amount = pi["sellerPILogisticsWithTax"]
                            logisticAddedFlag = true
                        }
                    }

                    let amount = parseFloat(parseFloat(eachSellerPIPunchItem.punchQty * eachSellerPIPunchItem.unitPrice).toFixed(2))
                    let IGSTVal = IGST ? (IGST / 100) * amount : '';
                    let SGSTVal = SGST ? (SGST / 100) * amount : '';
                    let CGSTVal = CGST ? (CGST / 100) * amount : '';

                    let actual_tds_amount = 0
                    if (eachSellerPIPunchItem.tdsValue) {
                        actual_tds_amount = eachSellerPIPunchItem.tdsValue * amount / 100
                    }

                    const verifiedUser = pmCompanyUsers.find(eachUser => eachUser.userId === pi.verifiedBy)

                    if(!verifiedUser){
                        console.log("verifiedUser", verifiedUser, pi)
                    }

                    purchase_data.push({
                        'UNIQUE ID': pi.sellerPINumber,
                        'BASE-VCH-TYPE': vch_type,
                        'VCH-TYPE': vch_type,
                        'VCH-NO': pi.sellerPINumber,
                        //'VCH-DATE': moment(vch_date).format('DD-MM-YYYY'),
                        'VCH-DATE': moment(pi.sellerPIUploadedDate).format(DATE_FORMAT),
                        'REF NO': pi.sellerPINumber,
                        'REF-DATE': pi.sellerPIDate ? moment(pi.sellerPIDate).format(DATE_FORMAT) : "",
                        //                            'PARTY'                    : pi.companyName, // pi.purchaseInvoice.sellerTradeName
                        'PARTY': trade_name,
                        'GSTIN': pi["sellerAddrs.gstinCode"],
                        'State': '',
                        'Term of Delivery': 'COD',
                        'ITEM NAME': hsn_description,
                        'HSN': eachSellerPIPunchItem.HSNCode,
                        'UNITS': eachSellerPIPunchItem.UOM,
                        'QTY': eachSellerPIPunchItem.punchQty,
                        'RATE': eachSellerPIPunchItem.unitPrice,
                        'Disc (%)': '',
                        'AMOUNT': amount ? parseFloat(amount) : 0,
                        'Other Charges Ledger': transportation_ledger,
                        'Other Charges Amt': transportation_amt ? parseFloat(transportation_amt) : 0,
                        'TRADE DISCOUNT LEDGER': '',
                        'TRADE DISCOUNT %': '',
                        'TRADE DISCOUNT AMT': '',
                        'IGST Ledger': IGST_Ledger,
                        'IGST%': IGST,
                        'IGST AMT': IGSTVal ? parseFloat(IGSTVal) : 0,
                        'CGST Ledger': CGST_Ledger,
                        'CGST%': CGST,
                        'CGST AMT': CGSTVal ? parseFloat(CGSTVal) : 0,
                        'SGST Ledger': SGST_Ledger,
                        'SGST%': SGST,
                        'SCGST AMT': SGSTVal ? parseFloat(SGSTVal) : 0,
                        'TDS Ledger': tds_ledger,
                        'TDS Amount': actual_tds_amount ? parseFloat(actual_tds_amount) : 0,
                        'PURCHASE LEDGER': purchase_ledger,
                        'NARRATION': `${pi.sellerPODocNo} - ${relatedPMBranch?.branchName} - ${branchHead}`,
                        'Auto Round Off': 'Yes',
                        'KAM Name': pi["firstName"] + " " + pi["lastName"],
                        'Verified By': getFullName(verifiedUser?.firstName, verifiedUser?.lastName),
                        'Ticket ID': relatedTicket ? relatedTicket.ticketId : null,
                        'Subject/Reason' : relatedTicket ? relatedTicket.title : null
                    })

                })

                if (logisticAddedFlag) {
                    if (logistics_amount != 0) {
                        purchase_data.push({
                            'UNIQUE ID': pi.sellerPINumber,
                            'BASE-VCH-TYPE': vch_type,
                            'VCH-TYPE': vch_type,
                            'VCH-NO': pi.sellerPINumber,
                            //'VCH-DATE': moment(vch_date).format('DD-MM-YYYY'),
                            'VCH-DATE': moment(pi.sellerPIUploadedDate).format(DATE_FORMAT),
                            'REF NO': pi.sellerPINumber,
                            'REF-DATE': pi.sellerPIDate ? moment(pi.sellerPIDate).format(DATE_FORMAT) : "",
                            //                   'PARTY'                    : pi.companyName, // pi.purchaseInvoice.sellerTradeName
                            'PARTY': trade_name,
                            'GSTIN': pi["sellerAddrs.gstinCode"],
                            'State': '',
                            'Term of Delivery': 'COD',
                            'ITEM NAME': 'Transportation Cost',
                            'HSN': logistics_hsn,
                            'UNITS': '',
                            'QTY': logistics_quantity,
                            'RATE': logisticsBeforeTax ? parseFloat(logisticsBeforeTax) : 0,
                            'Disc (%)': '',
                            'AMOUNT': logistics_quantity && logisticsBeforeTax ? round(logistics_quantity * logisticsBeforeTax, 2) : 0,
                            'Other Charges Ledger': '',
                            'Other Charges Amt': '',
                            'TRADE DISCOUNT LEDGER': '',
                            'TRADE DISCOUNT %': '',
                            'TRADE DISCOUNT AMT': '',
                            'IGST Ledger': logistics_igst_ledger,
                            'IGST%': logistics_igst_percentage,
                            'IGST AMT': logistics_igst_amount ? parseFloat(logistics_igst_amount) : 0,
                            'CGST Ledger': logistics_cgst_ledger,
                            'CGST%': logistics_cgst_percentage,
                            'CGST AMT': logistics_cgst_amount ? parseFloat(logistics_cgst_amount) : 0,
                            'SGST Ledger': logistics_sgst_ledger,
                            'SGST%': logistics_sgst_percentage,
                            'SCGST AMT': logistics_sgst_amount ? parseFloat(logistics_sgst_amount) : 0,
                            'TDS Ledger': logistics_tds_ledger,
                            'TDS Amount': logistics_tds_amt ? parseFloat(logistics_tds_amt) : 0,
                            'PURCHASE LEDGER': logistics_purchase_ledger,
                            'NARRATION': `${pi.sellerPODocNo} - ${relatedPMBranch?.branchName} - ${branchHead}`,
                            'Auto Round Off': 'Yes',
                            'KAM Name': pi["firstName"] + " " + pi["lastName"],
                            'Ticket ID': relatedTicket ? relatedTicket.ticketId : null,
                            'Subject/Reason' : relatedTicket ? relatedTicket.title : null
                        })
                    }
                }
            })
            setIsDataLoading(false)

            if (dataFormat === "CSV") {
                let csv = Papa.unparse(purchase_data, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "purchasedata.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(purchase_data)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'purchasedata.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }

            if(unVerifiedPIExists){
                dispatch(raiseToast({ severity: 'error', detail: "Warning: Non verified invoices found!", life: 6000 }))
            }
        }
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadPurchaseData("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadPurchaseData("CSV")
        }
    ]

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    }

    const handleSearch = () => {
        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        const updatedSearchParams = { ...searchParams }

        if (updatedSearchParams.searchBy !== "all") {
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const piWiseInvoiceParams = {
            ...paginationParams,
            ...updatedSearchParams,
        }

        // if(["all", "bookedBy", "verifiedBy"].includes(searchParams.searchBy)){
        if (!Object.keys(updatedSearchParams).some(label => docNoSearchLabels.includes(label))) {
            if(!searchParams.fromDate || !searchParams.toDate){
                return dispatch(raiseToast({severity:'error', detail: "Please select from date and to date" , life: 3000}))
            }
            let from_date = searchParams.fromDate
            let to_date = searchParams.toDate
            if (searchParams.fromDate) {
                from_date = moment(searchParams.fromDate, "DD.MM.YYYY").toDate()
            }
            if (searchParams.toDate) {
                to_date = moment(searchParams.toDate, "DD.MM.YYYY").toDate()
            }
            const date_difference = moment(new Date(to_date)).diff(moment(new Date(from_date)), 'days')

            if (date_difference > 180) {
                return dispatch(raiseToast({ severity: 'error', detail: "Please select Date range within 6 month", life: 3000 }))
            }
        } else {
            piWiseInvoiceParams.dateType = null
        }

        if (!errorFound) {
            dispatch(fetchInvoiceBookingList(piWiseInvoiceParams))
        }
    }

    return (
        <div className="p-card" style={{ border: "1px solid #e9ecef" }} onKeyDown={handleSearchKeyPress}>
            <Loading visible={isDataLoading}/>
            <Toast ref={Toast} />
            <div className="grid">
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{ label: '', value: 'all' }]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })

                            return (
                                <div className={`flex flex-column col-12 m-0 p-0 ${isSearchByVisible ? 'search-by-filter-set' : ''}`}>
                                    <div className={`flex flex-column col-12`}>
                                        {['kamName'].includes(searchParams.searchBy) ? (
                                            <AutoCompleteField
                                                value={searchParams.searchText}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(searchParams.searchBy, e.query)}
                                                field="displayName"
                                                labelText="Search Text"
                                                onChange={handleSearchOnChange}
                                                name="searchText"
                                                dropdown
                                                refName={searchTextRef}
                                            />
                                        ) : (
                                            <TextInputField
                                                name="searchText"
                                                labelText="Search Text"
                                                placeholder="No Filter"
                                                refName={searchTextRef}
                                                value={searchParams["searchText"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        )}
                                    </div>
                                    {(searchParams.searchText || isSearchByLocked)  && (
                                        <>
                                            <div className="flex justify-content-end p-0 col-12 remove-opt" style={{height: '0px'}}>
                                            <i
                                                className={`pi ${isSearchByLocked ? 'pi-lock' : 'pi-lock-open'}`}
                                                style={{ position: 'absolute', top: '-2px', left: '70px', cursor: 'pointer', color: 'orange', zIndex: '1000' }}
                                                onClick={() => handleSearchByLock()}
                                            ></i>
                                            </div>
                                            <div className="flex flex-column col-12" style={{marginTop: '-12px'}}>
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                isSearchByLocked={isSearchByLocked}
                                                handleSearchByLock={handleSearchByLock}
                                                isLockVisible={true}
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                            </div>
                                        </>
                                    )}
                                </div>
                            )
                        }

                        if (eachOption.type === "DATE") {
                            return (
                                <>
                                    <DateFilter 
                                        disabled={docNoSearchLabels.includes(searchParams.searchBy)}
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }
                        
                        if (eachOption.type === "SELECT") {
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }

                        if (eachOption.type === "AUTO_COMPLETE") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <AutoCompleteField
                                                value={searchParams[eachOption.name]}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(eachOption.name, e.query)}
                                                field="displayName"
                                                labelText={eachOption.label}
                                                onChange={handleSearchOnChange}
                                                name={eachOption.name}
                                                dropdown
                                            />
                                        </div>
                                    }
                                </>
                            )
                        }
                    })
                }

                <div className="flex flex-column col-12">
                    <label style={{ fontSize: "12px" }}>Verification Status:</label>
                    <div className="flex flex-row justify-content-between mt-2">
                        <CheckboxField name="displayVerifiedInvoices" onChange={handleCheckboxSelect} checked={searchParams.displayVerifiedInvoices} label="Verified" />
                        <CheckboxField name="displayUnVerifiedInvoices" onChange={handleCheckboxSelect} checked={searchParams.displayUnVerifiedInvoices} label="Not Verified" />
                    </div>
                </div>

                <div className="flex flex-column col-12">
                    <div className="flex flex-row">
                        <CheckboxField name="openIssues" onChange={handleCheckboxSelect} checked={searchParams.openIssues} label="Open Issues" />
                    </div>
                </div>
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}>
                            <Button label="Search" style={{ flexGrow: 1 }} className="py-2" onClick={handleSearch} disabled={isLoading} />
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3" onClick={(e) => downloadMenu.current.toggle(e)} disabled={isLoading} permissions={[248]}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PIInvoiceBookingSearch;